/**
 * Portfolio grid filtering
 *
 */
// Setup global namespace object if not already
window.pyatt = window.pyatt || {};

/**
 * Contact Form functions for CF7
 *
 * Adds placeholder text overlays on inputs
 */
pyatt.contactForm = (function (pyatt, $, window, document, undefined) {

    var $form,
        $inputWraps,
        inputElements = 'input, textarea',
        $map_el,
        $contactFormLink,
        $newsletterFormLink;

    var map_styles = [
        {
            "featureType": "administrative",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": "-100"
                }
            ]
        },
        {
            "featureType": "administrative.province",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": -100
                },
                {
                    "lightness": 65
                },
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": -100
                },
                {
                    "lightness": "50"
                },
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": "-100"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "all",
            "stylers": [
                {
                    "lightness": "30"
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "all",
            "stylers": [
                {
                    "lightness": "40"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": -100
                },
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "hue": "#ffff00"
                },
                {
                    "lightness": -25
                },
                {
                    "saturation": -97
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels",
            "stylers": [
                {
                    "lightness": -25
                },
                {
                    "saturation": -100
                }
            ]
        }
    ];

    function init() {

        $form = $('[id^="wpcf7-"]');
        $inputWraps = $form.find('.input-wrap p');
        $contactFormLink = $('.contact-form-link');
        $newsletterFormLink = $('.newsletter-form-link');

        //Use label as placeholder text
        setPlaceHolderText();

        // Add modal link to contact menu link
        $contactFormLink.attr('data-reveal-id', 'contactModal' );
        // Add click handler
        $contactFormLink.on('click', contactFormClickHandler );

        // Add modal link to menu link
        $newsletterFormLink.attr('data-reveal-id', 'newsletterModal' );
        // Add click handler
        $newsletterFormLink.on('click', contactFormClickHandler );

    }

    function initMaps() {
        $map_el = $('#map');

        // Find marker elements within map.
        var $markers = $('.contact-locations .marker');
        
        // Create gerenic map.
        var mapArgs = {
            zoom		: $map_el.data('zoom') || 16,
            styles      : map_styles,
            streetViewControl: false,
            mapTypeControl: false,
            mapTypeId	: google.maps.MapTypeId.ROADMAP
        };
        var map = new google.maps.Map( $map_el[0], mapArgs );
        
        // Add markers.
        map.markers = [];
        $markers.each(function(){
            initMarker( $(this), map );
        });
        
        // Center map based on markers.
        centerMap( map );
        
        // Return map instance.
        return map;
    }

    /**
     * initMarker
     *
     * Creates a marker for the given jQuery element and map.
     *
     * @date	22/10/19
     * @since	5.8.6
     *
     * @param	jQuery $el The jQuery element.
     * @param	object The map instance.
     * @return	object The marker instance.
     */
    function initMarker( $marker, map ) {

        // Get position from marker.
        var lat = $marker.data('lat');
        var lng = $marker.data('lng');
        var latLng = {
            lat: parseFloat( lat ),
            lng: parseFloat( lng )
        };

        // Create marker instance.
        var marker = new google.maps.Marker({
            position : latLng,
            icon:'/wp-content/themes/fergusonpyattarchitects/dist/images/map-markers/accent.png',
            map: map
        });

        // Append to reference for later use.
        map.markers.push( marker );

        // If marker contains HTML, add it to an infoWindow.
        if( $marker.html() ){
            
            // Create info window.
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html()
            });

            // Show info window when marker is clicked.
            google.maps.event.addListener(marker, 'click', function() {
                infowindow.open( map, marker );
            });
        }
    }

    /**
     * centerMap
     *
     * Centers the map showing all markers in view.
     *
     * @date	22/10/19
     * @since	5.8.6
     *
     * @param	object The map instance.
     * @return	void
     */
    function centerMap( map ) {

        // Create map boundaries from all map markers.
        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function( marker ){
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng()
            });
        });

        // Case: Single marker.
        if( map.markers.length == 1 ){
            map.setCenter( bounds.getCenter() );
        
        // Case: Multiple markers.
        } else{
            map.fitBounds( bounds );
        }
    }


    /**
     * ContactModal click handler
     *
     * @param event
     */
    function contactFormClickHandler(event) {
        //close mobile menu if open
        if ( $('nav.top-bar').hasClass('expanded') ) {
            $(".toggle-topbar a").trigger('click');
        }
    }


    /**
     * Use label as placeholder text in cf7
     *
     */
    function setPlaceHolderText() {
        //when labels are clicked focus on related input elements
        $inputWraps.children('.cf7_label').click(function(){
            $(this).parent().find(inputElements).focus();
        });
        //action when input elements are focused
        $inputWraps.find(inputElements)
            //hide label
            .focus(function(){
                $(this).parents('.input-wrap').find('.cf7_label').hide();
            })
            //show label if no content
            .blur(resetInputLabels);
        //on page reload check for values
        $inputWraps.find(inputElements).each(resetInputLabels);
    }


    /**
     * Reset input labels helper
     *
     */
    //reset input labels
    function resetInputLabels() {
        var $this = $(this);
        if( $this.val() == "" ){
            $this.parents('.input-wrap').find('.cf7_label').show();

        }
    }

    // What to make public
    return {
        init : init,
        initMaps: initMaps
    };


}(window.pyatt = window.pyatt || {}, jQuery, window, window.document));
